module.exports = __webpack_public_path__ + "static/prozesse-9845d717874cd35393f1db3f67d03326.jpg";